/* eslint-disable */
export default {
  noActiveCalls: 'Nenhuma chamada ativa',
  noCalls: 'Nenhum resultado encontrado.',
  currentCall: 'Chamada atual',
  ringCall: 'Chamada sonora',
  onHoldCall: 'Chamada em espera',
  historyCalls: 'Chamadas anteriores',
  otherDeviceCall: 'Chamadas em andamento nos meus outros dispositivos',
  searchPlaceholder: 'Pesquisar...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
